// @info 多言語対応不要
export const ORDER_STATUSES = {
  arriveComplete: '送達済',
  orderPending: '注文保留',
}
